import React from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
import { languageSlice } from '../../../state/slices/languageSlice'


const LanguageSelection = ({ hideSv }) => {

    const language = useSelector((state) => state.language)
    const dispatch = useDispatch()
    const { changeLanguage } = bindActionCreators(languageSlice.actions, dispatch)

    const handleLanguageChange = (language) => {
        changeLanguage(language) // redux
    }


    return(
        <div className="flex-row space-center margin-top-bot">
            <LanguageButton
                language={language}
                buttonLanguage={'fi_FI'}
                setLanguage={handleLanguageChange}
                textKey={'SUOMI'}
            />
            {!hideSv && (
                <LanguageButton
                    language={language}
                    buttonLanguage={'sv_SE'}
                    setLanguage={handleLanguageChange}
                    textKey={'SVENSKA'}
                />
            )}

            <LanguageButton
                language={language}
                buttonLanguage={'en_US'}
                setLanguage={handleLanguageChange}
                textKey={'ENGLISH'}
            />
        </div>
    )
}

export default LanguageSelection

const LanguageButton = ({ language, buttonLanguage, setLanguage, textKey }) => {
    return(
        <button
            className={`language-button ${language === buttonLanguage ? 'active-language' : ''}`}
            onClick={() => setLanguage(buttonLanguage)}
        >
            {textKey}
        </button>
    )
}


// WEBPACK FOOTER //
// ./src/components/materialCommitment/commitment/LanguageSelection.jsx